import { forwardRef } from 'react'
import { IconButton } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import { getNavigationAndActionIcon } from '@DS/components/icons/navigationAndActionIcons'

import { type AdditionalMessageButtonProps } from '../AdditionalMessage.types'
import * as styles from '../styles'

const InfoIcon = getNavigationAndActionIcon('info')

const AdditionalMessageButton = forwardRef<HTMLButtonElement, AdditionalMessageButtonProps>((props, ref) => {
  const theme = useTheme()

  return (
    <IconButton {...props} ref={ref} color="primary" css={styles.button(theme)}>
      <InfoIcon css={styles.icon} />
    </IconButton>
  )
})

export default AdditionalMessageButton
